import { toolkitUrls } from '@/util/links'
import { AccessPointsUtil } from '@/util/access_points'
import type { GoalHit, StandardSetRef } from '@/goals/goal_types'

export const RESTRICTION_PREMIUM = 'premium'
export type GoalCardRestriction = '' | typeof RESTRICTION_PREMIUM

export function goalLevelLabel({ level }: Pick<GoalHit, 'level'>): string {
  return AccessPointsUtil.labelsMap[level] ?? ''
}

export interface BrowseGoalFilters {
  subject?: string
  subjectDomain?: string
}

export type StandardsByLongRef = Record<string, { standard_short_ref: string }>

export const PLACEHOLDER_STANDARD_REF = 'AAA.111'

// The anchor page draws its breadcrumb back to these browse results from them.
function anchorPageBreadcrumbParams({ subject, subjectDomain }: BrowseGoalFilters): URLSearchParams {
  const breadcrumbParams = new URLSearchParams()
  if (subject) {
    breadcrumbParams.set('browse_subject', subject)
  }
  if (subjectDomain) {
    breadcrumbParams.set('browse_domain', subjectDomain)
  }
  return breadcrumbParams
}

export function browseGoalCardUrl({ uuid }: Pick<GoalHit, 'uuid'>, browseFilters: BrowseGoalFilters): string {
  const anchorPageUrl = toolkitUrls.anchorPage(uuid)
  const breadcrumbQuery = anchorPageBreadcrumbParams(browseFilters).toString()
  if (!breadcrumbQuery) {
    return anchorPageUrl
  }
  return `${anchorPageUrl}?${breadcrumbQuery}`
}

function refInStandardSet(goal: GoalHit, standardSetCode: string): StandardSetRef | undefined {
  return goal.standard_set_refs?.find((ref) => ref.standard_set_code === standardSetCode)
}

export function hasStandardSet(goal: GoalHit, standardSetCode: string): boolean {
  return refInStandardSet(goal, standardSetCode) !== undefined
}

export function shortStandardRef(goal: GoalHit, standardSetCode: string, standardsByLongRef: StandardsByLongRef): string {
  const ref = refInStandardSet(goal, standardSetCode)
  if (!ref) {
    return ''
  }
  return standardsByLongRef[ref.standard_long_ref]?.standard_short_ref ?? ''
}
